import React from 'react';
import { Utils } from '../../common';

const DocViewer = ({ doc }) => {
  let height = window.innerHeight - 167;
  if (height < 200) height = 200;

  const fileUrl = Utils.viewerLink(doc, `cqcs/downloadud/${doc}`);
  const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;

  return (
    <iframe
      src={viewerUrl}
      width="100%"
      height={height}
      style={{ border: 'none' }}
      title="Document Viewer"
    />
  );
};

export default DocViewer;